import {
  validatorMaxLength1000,
  validatorMaxLength40,
  validatorRequired,
} from '~src/services/validators';
import { composeValidators } from '~src/shared/reactFinalForm/validators';

import { TranslatableField } from './interfaces';

export const nameDescrFields: TranslatableField[] = [
  {
    name: 'name',
    label: 'x.shared.name_and_description_form.input.placeholder.name',
    validator: composeValidators([validatorRequired, validatorMaxLength40]),
    translationValidator: validatorMaxLength40,
  },
  {
    name: 'description',
    label: 'x.shared.name_and_description_form.input.placeholder.description',
    validator: validatorMaxLength1000,
    translationValidator: validatorMaxLength1000,
  },
];
